import { createSlice } from '@reduxjs/toolkit';
import { AuditElementType } from '../../utils/auditTypes';

export const name = 'auditFacet';

const initialState: AuditFacetState = {
	user: null,
	elementType: null,
	startTime: null,
	endTime: null,
	page: 0
};

export const auditFacetSlice = createSlice({
	name,
	initialState,
	reducers: {
		setUserFacet: (state, { payload }): void => {
			state.user = payload;
			state.page = initialState.page;
		},
		setElementTypeFacet: (state, { payload }): void => {
			state.elementType = payload;
			state.page = initialState.page;
		},
		setStartTimeFacet: (state, { payload }): void => {
			state.startTime = payload;
			state.page = initialState.page;
		},
		setEndTimeFacet: (state, { payload }): void => {
			state.endTime = payload;
			state.page = initialState.page;
		},
		setAuditDateFacet: (state, { payload }): void => {
			state.startTime = payload ? `${payload}T00:00:00` : null;
			state.endTime = payload ? `${payload}T23:59:59` : null;
			state.page = initialState.page;
		},
		setPage: (state, { payload }): void => {
			state.page = payload;
		},
		resetAllFacets: (state): void => {
			state.user = initialState.user;
			state.elementType = initialState.elementType;
			state.startTime = initialState.startTime;
			state.endTime = initialState.endTime;
			state.page = initialState.page;
		}
	}
});

export const { setUserFacet, setElementTypeFacet, setStartTimeFacet, setEndTimeFacet, setAuditDateFacet, setPage, resetAllFacets } =
	auditFacetSlice.actions;

export default auditFacetSlice.reducer;

export interface AuditFacetState {
	user: string | null;
	elementType: AuditElementType | null;
	startTime: string | null;
	endTime: string | null;
	page: number;
}
